/**
 *  Populate Nutritional tab content on load
 */
const updateNutritionalTab = async () => {
    const $nutritionalTabHeader = $(".js-nutritional-tab-header");
    const $nutritionalTabAnchor = $(".js-nutritional-tab-anchor");
    const $nutritionalTabContent = $(".js-nutri-tab-wrapper");
    const $nutritionalTableTabHeader = $(".js-nutritional-table-tab-header");
    const $nutritionalTableTabAnchor = $(".js-nutritional-table-tab-anchor");
    const $nutritionalTableTabContent = $(".js-nutri-table-tab-wrapper");
    const url = $nutritionalTabAnchor.data("url");
    const isTabLoaded = $nutritionalTabAnchor.attr("data-isloaded") == "true" ? true : false;

    // Return if content is already loaded
    if (isTabLoaded || !url) { return; }

    try {
        await $.ajax({
            url: url,
            type: "get",
            dataType: "html",
            success: data => {
                if (!$.trim(data)) { return; }

                $nutritionalTabContent.html(data);
                $nutritionalTabContent.removeClass("d-none");
                $nutritionalTabAnchor.attr("data-isloaded", "true");
                $nutritionalTabAnchor.removeClass("d-none");
                $nutritionalTabHeader.removeClass("d-none");
                let nutritionalArea = $nutritionalTabContent.find(".nutritional-information-area"); 

                if (nutritionalArea.find("div").length) {
                    $nutritionalTableTabHeader.removeClass("d-none");
                    $nutritionalTableTabAnchor.removeClass("d-none");
                    $nutritionalTableTabAnchor.attr("data-isloaded", "true");
                    $nutritionalTableTabContent.removeClass("d-none");
                    $nutritionalTableTabContent.append(nutritionalArea);
                }

                $(".ct-pdp--description-tabs").removeClass("hidden");
            }
        });
    } catch (e) {
        console.error(e);
    }
};

export { updateNutritionalTab };
